import type { Components } from '@mui/material/styles';

export default function MuiBottomNavigationAction(): Components['MuiBottomNavigationAction'] {
  return {};
}
